export const INVITE_LINK_PATH = "/join/:code";

export const isInviteLinkPath = (pathname = "") =>
  /^\/join\/[^/]+\/?$/.test(pathname);
